import { lazy } from 'react';
import {
  useSurrenderRoot,
  type SurrenderRootRequest,
} from 'src/apis/surrender-service/use-surrender-root';
import { useSurrenderSettings } from 'src/apis/surrender-service/use-surrender-settings';
import { PageSpinner } from 'src/components/spinner-container';
import type { Successful } from 'src/hooks/use-axios';
import { Forbidden } from 'src/utils/errors';

const Page = lazy(() => import('./page'));

export const SurrenderSettings = () => {
  const surrenderRoot = useSurrenderRoot();

  if (!surrenderRoot.response) return <PageSpinner />;

  if (!surrenderRoot.response.data._links.getSettings) {
    throw new Forbidden();
  }

  return <ProtectedSurrenderSettings surrenderRoot={surrenderRoot} />;
};

const ProtectedSurrenderSettings = ({
  surrenderRoot,
}: {
  surrenderRoot: Successful<SurrenderRootRequest>;
}) => {
  const surrenderSettings = useSurrenderSettings({ surrenderRoot });

  if (!surrenderSettings?.response) return <PageSpinner />;

  return <Page surrenderSettings={surrenderSettings} />;
};
